import loadScript from 'load-script2'
import constants from '@/constants.js'
let gscript = null
let baiduScript = null
let gopt = null

const debug = false

export default {
  loadHandled: false,
  loadGoogleScript: async function (to) {
    if(window.location.hostname !== process.env.VUE_APP_LIVE_HOST) {
      if(!debug){
        return
      }
      
    }
    if(gscript === null){
      try {
        gscript = await loadScript('https://www.googletagmanager.com/gtag/js?id=' + process.env.VUE_APP_GTAG_ID)
        console.log('loaded gscript')
      }
      catch(err){
        console.log(err)
      }
    }
    
    if(!window.gtag){
      window.dataLayer = window.dataLayer || [];
      window.gtag = function (){
        window.dataLayer.push(arguments);
      }
      window.gtag('js', new Date());
    }
    //console.log('calling gtag config', to.path)
    window.gtag('config', process.env.VUE_APP_GTAG_ID, {'page_path': to.path});
    if(gopt === null) {
      gopt = loadScript('https://www.googleoptimize.com/optimize.js?id=' + process.env.VUE_APP_GOPT_ID)
      console.log('loaded gopt')
    }
  },
  loadBaidu: async function () {
    if(baiduScript === null)
    {
      try {
        baiduScript = await loadScript('https://hm.baidu.com/hm.js?' + process.env.VUE_APP_BAIDU_ID)
      }
      catch(err) {
        console.log(err)
      }
    }
  },
  getUtmParams: function(to, store) {
    if(to.query) {
      let utms = null
      if(to.query.utm_source) {
        utms = {}
        utms.utm_source =  to.query.utm_source
        if(to.query.utm_campaign) {
          utms.utm_campaign = to.query.utm_campaign
        }
        if(to.query.utm_medium) {
          utms.utm_medium = to.query.utm_medium
        }
      }
      if(utms) {
        store.commit('setUtms', utms)
      }
    }
    if(store.state.referer === null) {
      if(document.referrer) {
        let r = document.referrer
        if(r !== '') {
          if(r.indexOf('illustrationx.com') < 0) {
            store.commit('setReferer', r)
          }
        }
      }
    }
  },
  handleLoad: function (to, store) {
    this.loadHandled = true
    this.getUtmParams(to, store)
  },
  loadGoogle: async function (to, store) {
    if(store.state.lang !== 'CN'){
      this.loadGoogleScript(to)
    }
    else {
      this.loadBaidu()
    }
    constants.logVisit(to.path)
    if(!this.loadHandled) {
      this.handleLoad(to, store)
    }
  }
}